import { gql } from 'graphql-request'

export const UPDATE_USER_TASK_HOST_RESCUED = gql`
  mutation UPDATE_USER_TASK_HOST_RESCUED($userTaskHostId: Int!) {
    updateUserTaskHostRescued(userTaskHostId: $userTaskHostId) {
      error
      status
      data {
        dateRescued
        userTaskBonusType
        value
        itemPackage {
          id
          name
          # name
          # imgItem
          # itemTypeBuy
          # durationInDay
          # valueItem
          # itemType
        }
      }
    }
  }
`
